module.exports = __webpack_public_path__ + "fonts/gothica1-light-webfont.87871a6.woff2";